import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-868e1c92"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "laboratory-item-detail-container"
};
const _hoisted_2 = {
  class: "detail-container-bg-img"
};
const _hoisted_3 = {
  class: "head"
};
const _hoisted_4 = {
  class: "bread-crumb"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 您当前所在的位置 ： ");

const _hoisted_6 = ["href"];

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" > 详情 ");

const _hoisted_8 = {
  class: "base-dis"
};
const _hoisted_9 = {
  class: "category-text base-dis-li"
};
const _hoisted_10 = {
  class: "text-li top-title"
};
const _hoisted_11 = {
  class: "title-h1"
};
const _hoisted_12 = {
  class: "text-li top-catergory-ul"
};
const _hoisted_13 = {
  class: "top-catergory-li"
};
const _hoisted_14 = {
  class: "top-catergory-li"
};
const _hoisted_15 = {
  class: "top-catergory-li"
};
const _hoisted_16 = {
  class: "top-catergory-li"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  class: "category-pic base-dis-li"
};
const _hoisted_19 = {
  class: "laboratory-item-detail-main"
};
const _hoisted_20 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_LaborItemDetailWrapper = _resolveComponent("LaborItemDetailWrapper");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    menuCode: "13200"
  }, null, 8, ["menuInfo"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "img-bg",
    style: _normalizeStyle({
      backgroundImage: `url(${$data.laboratoryItemDetail.cover_url || ''})`
    })
  }, null, 4)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("a", {
    class: "link",
    href: `/virtual.html?menuId=${$data.menuInfo.menu_id}&name=${$data.menuInfo.nav_name}`
  }, _toDisplayString($data.menuInfo.nav_name), 9, _hoisted_6), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($data.laboratoryItemDetail.name || "-"), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, "实验分类：" + _toDisplayString($data.laboratoryItemDetail.classify_name || `-`), 1), _createElementVNode("div", _hoisted_14, " 实验学时：" + _toDisplayString($data.laboratoryItemDetail.period || "-"), 1), _createElementVNode("div", _hoisted_15, " 学科分类：" + _toDisplayString($data.laboratoryItemDetail.subject || "-"), 1), _createElementVNode("div", _hoisted_16, " 建设学校：" + _toDisplayString($data.laboratoryItemDetail.creat_school || '--'), 1)]), _createElementVNode("div", {
    class: "text-li mid-dis",
    innerHTML: $data.laboratoryItemDetail.experiment_introduce || '-'
  }, null, 8, _hoisted_17), $data.laboratoryItemDetail.experiment_link ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "jump_catergory",
    onClick: _cache[1] || (_cache[1] = $event => $options.jumpCatergory())
  }, "我要做实验")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: "category-pic-child base-dis-li-child",
    style: _normalizeStyle({
      backgroundImage: `url(${$data.laboratoryItemDetail.cover_url || ''})`
    })
  }, null, 4)])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_LaborItemDetailWrapper, {
    "detail-id": 1,
    "laboratory-item-detail": $data.laboratoryItemDetail
  }, null, 8, ["laboratory-item-detail"])])])]);
}